/* eslint-disable require-jsdoc */

import { isValid } from '../../../../../utils/validate';
import {defaultImg} from '../../../utils/defaultImg';
import {getBandImage} from './bandLogic';
import {getBandSocialIcons, hasSocial} from './bandSocial';

function getBandsHtml(bands) {
  // get bands names and social
  if (!Array.isArray(bands) || !bands.length) {
    return '';
  }
  const bandLineUp = getBands(bands);

  return `<section class="hearby-section-thelineup">
                   <h2>The line up</h2>
                   <div class="hearby-event-details-artists">
                    ${bandLineUp}
                   </div>
                </section>
                `;
}

function getBands(bands) {
  let bandsHtml = '';
  bands.forEach((band) => (bandsHtml += getBand(band)));
  return bandsHtml;
}
function getBandSocial(band) {
  return hasSocial(band) ? getBandSocialIcons(band.bandSocialMedia) : '';
}
function getSpfyEmbed(spfyId) {
  const spfyEmbed = `<div class="heda-player">
                      <iframe src="https://open.spotify.com/embed/artist/${spfyId}" loading='lazy' height="80" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>
                    </div>`
  return isValid(spfyId) ? spfyEmbed : '';
}
function getBand(band) {
  const bandId = band.bandId;
  const image = getBandImage(band.bandImagePath);
  const defaultImage = defaultImg();
  const bandName = band.bandName;
  const spfyId = band.bandPlaylistSpfyId;
  const spfyEmbed = getSpfyEmbed(spfyId);
  const bandSocial = getBandSocial(band);
  return `<div class="hearby-details-row heda-artist">
            <div class="hearby-col hearby-col-60">
              <div class="heda-artist-avatar">
                  <a href="https://hearby.com/artist-detail/?bandId=${bandId}" target="_blank"><img src="${image}" onerror="this.onerror=null;this.src='${defaultImage}';"></a>
              </div>
              <div class="heda-artist-name">
                  <a href="https://hearby.com/artist-detail/?bandId=${bandId}" target="_blank" class="heda-artist-name-link">${bandName}</a>
                  ${bandSocial}
              </div>
            </div>
            <div class="hearby-col hearby-col-40">
            ${spfyEmbed}
            </div>
          </div>`;
}
export {getBandsHtml};
